// extracted by mini-css-extract-plugin
export default {"widget":"styles_widget__6gpGQ","col-1":"styles_col-1__m+9i9"};